import { SubscriptionManager } from "@/components/agent/SubscriptionManager";
import { BoostManager } from "@/components/agent/BoostManager";
import { PageHeader, Button } from "@/components/shared";
import { useNavigate } from "react-router-dom";

export default function SubscriptionPage() {
  const navigate = useNavigate();

  return (
    <div className="max-w-3xl mx-auto px-4 py-8 space-y-8">
      <div>
        <div className="flex items-center justify-between mb-2">
          <PageHeader
            title="Subscription"
            subtitle="Choose a plan to start responding to property owner requests in your region"
          />
          <Button variant="secondary" onClick={() => navigate("/agent/billing")} className="text-sm shrink-0">
            Billing History
          </Button>
        </div>
        <SubscriptionManager />
      </div>
      <div>
        <PageHeader
          title="Ranking Boosts"
          subtitle="Boost your visibility in specific suburbs"
        />
        <BoostManager />
      </div>
    </div>
  );
}
